import { persistentAtom } from "./utils/persistentAtom";

export const activeStationIndexState = persistentAtom("activeStationIndex", 0);
